<template>
<transition name="fade2">
  <div class="cookies bg-dark-purple w-100 flex a_center j_sb" v-if="cookies">
    <div class="cookies__left-col flex column">
      <span class="f-16 bold f-white mb-10">
        <!-- {{ $fn.tr("ქუქების პოლიტიკა") }} -->
        {{
          _.get(
            $store.state.main.indx.cookies, 'title')
        }}
      </span>
      <p class="f-white regular" v-html="_.get(
            $store.state.main.indx.cookies, 'teaser')">
        <!-- {{
          windowWidth >= 1207
            ? _.get(
                $store.state.main.indx.widgets,
                "cookies_text.cookies_text.teaser"
              )
            : _.get(
                $store.state.main.indx.widgets,
                "cookies_text.cookies_text_sm.teaser"
              )
        }}
        <a
          target="_blank"
          :href="
            _.get(
              $store.state.main.indx.widgets,
              'cookies_text.cookies_text.url'
            )
          "
          class="f-white underline"
        >
          {{
            _.get(
              $store.state.main.indx.widgets,
              "cookies_text.cookies_text.title"
            )
          }}
        </a> -->
      </p>
    </div>
    <div class="cookies__right-col flex">
      <div class="cookies__accept_btn bg-white br-6 pointer" @click="accept_cookies">
        <span class="bold uppercase">{{ $fn.tr("ვეთანხმები") }}</span>
      </div>
      <div
        class="cookies__configure_btn bg-light-purple br-6 pointer flex a_center j_center"
        @click="toggle_modal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="20"
          height="19"
          viewBox="0 0 20 19"
        >
          <defs>
            <clipPath id="clip-path">
              <rect
                id="Rectangle_1005"
                data-name="Rectangle 1005"
                width="20"
                height="19"
                fill="#fff"
              />
            </clipPath>
          </defs>
          <g id="customize" clip-path="url(#clip-path)">
            <path
              id="Path_1385"
              data-name="Path 1385"
              d="M14.171,20.527a8.505,8.505,0,0,1-2.663.027.613.613,0,0,1-.443-.4l-.5-1.729a1,1,0,0,0-.4-.512L8.341,16.866a.973.973,0,0,0-.642-.085l-1.715.46a.6.6,0,0,1-.564-.177,8.472,8.472,0,0,1-1.273-2.191.613.613,0,0,1,.121-.582l1.29-1.345a1,1,0,0,0,.242-.6v-2.1a.972.972,0,0,0-.248-.6L4.266,8.357a.6.6,0,0,1-.126-.576A10.208,10.208,0,0,1,5.4,5.605a.614.614,0,0,1,.565-.185L7.8,5.871a1.006,1.006,0,0,0,.644-.092l1.82-1.051a.972.972,0,0,0,.394-.514l.464-1.731a.594.594,0,0,1,.436-.4,8.468,8.468,0,0,1,2.5.012.6.6,0,0,1,.435.4l.46,1.715a.973.973,0,0,0,.394.514L17.17,5.779a.973.973,0,0,0,.642.085l1.715-.46a.6.6,0,0,1,.564.177A8.5,8.5,0,0,1,21.4,7.858a.6.6,0,0,1-.13.578L20.063,9.643a.972.972,0,0,0-.248.6v2.1a.971.971,0,0,0,.248.6l1.225,1.225a.607.607,0,0,1,.131.578,9.314,9.314,0,0,1-.6,1.232,9.476,9.476,0,0,1-.707,1.064.6.6,0,0,1-.564.178l-1.629-.437a.972.972,0,0,0-.642.085l-1.821,1.051a.971.971,0,0,0-.394.514l-.453,1.691A.612.612,0,0,1,14.171,20.527Zm-5.6-9.2a4.2,4.2,0,1,1,4.2,4.2A4.207,4.207,0,0,1,8.573,11.322Z"
              transform="translate(-2.959 -2.004)"
              fill="#fff"
              fill-rule="evenodd"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  mixins: [resize_handler],
  data() {
    return {
        cookies: null,
    };
  },

  created(){
     	if(!this.$cookies.get("validCookies")){
        this.cookies = true;
      } else {
        this.cookies = null;
      }    
  },
  methods: {
      	accept_cookies(){
          let cookiesValue = _.get(this.$store.state.main.indx, "cookies.places");
          if (cookiesValue && Object.keys(cookiesValue)?.length) {
            cookiesValue = Object.keys(cookiesValue).join(",");
          }
          this.$cookies.set("validCookies", cookiesValue, "1m");

		  		this.cookies = false;
		  	},
        toggle_modal(){
            this.$store.state.main.cookies_configurator_modal = !this.$store.state.main.cookies_configurator_modal;
        }
  },
  watch: {
    "$store.state.main.cookies_hide"(ns) {
      if (ns) {
        this.cookies = null;
      }
    },
  },
};
</script>

<style lang="sass">
.cookies
    position: fixed
    bottom: 0
    left: 0
    padding-left: 144px
    padding-right: 144px
    padding-bottom: 31px
    padding-top: 34px
    z-index: 990
    &__left-col
        padding-right: 58px
    &__accept_btn
        padding-left: 30px
        padding-right: 30px
        padding-bottom: 8px
        padding-top: 9px
        margin-right: 15px
        height: 41px
        span
            transition: .4s
        @media (min-width: 1024px)
            &:hover
                span
                    color: #7063E9

    &__configure_btn
        height: 41px
        padding-left: 7px
        padding-right: 7px
        transition: .4s
        svg path
            transition: .4s
        @media (min-width: 1024px)
            &:hover
                background-color: white
                svg path
                    fill:  #7063E9
    @media (max-width: 1919px)
        padding-left: 104px
        padding-right: 104px
    @media (max-width: 1439px)
        padding-left: 55px
        padding-right: 55px
        &__left-col
            padding-right: 38px
    @media (max-width: 1206px)
        padding-left: 34px
        padding-right: 34px
        padding-top: 21px
        padding-bottom: 21px
        &__left-col
            padding-right: 24px
    @media (max-width: 767px)
        padding-left: 16px
        padding-right: 16px
        padding-top: 21px
        padding-bottom: 21px
        flex-direction: column
        &__left-col
            padding-right: 0
        &__right-col
            padding-top: 15px
</style>
